import React from "react";
import { DeleteOutline, PictureAsPdf } from "@mui/icons-material";
import {
  Box,
  Chip,
  Stack,
  Radio,
  Button,
  Select,
  Checkbox,
  MenuItem,
  TextField,
  RadioGroup,
  InputLabel,
  FormControl,
  ListItemText,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";

const SourceIdVerificationComp = ({
  files,
  error,
  loading,
  violation,
  handleChange,
  sourceIdStatus,
  deleteModalOpen,
  isVerifyDisabled,
  emailFilesOptions,
  deleteSelectedFile,
  getFilesBySourceId,
  isSourceIdDisabled,
  selectedFileFromMail,
  selectedFileFromEmail,
  isSourceIdTypeDisabled,
  handleSelectFileFromEmail,
}: any) => {
  return (
    <div>
      <Stack maxWidth={"380px"}>
        <div className="sub-title-text-2" style={{ margin: "12px 0px" }}>
          Source ID
        </div>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="sourceIdType"
            value={violation.sourceIdType || ""}
            onChange={handleChange}
          >
            <FormControlLabel
              disabled={isSourceIdTypeDisabled()}
              value="mail"
              control={<Radio />}
              label="Mail"
            />
            <FormControlLabel
              disabled={isSourceIdTypeDisabled()}
              value="email"
              control={<Radio />}
              label="Email"
            />
          </RadioGroup>
        </FormControl>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "500px",
          }}
        >
          <TextField
            style={{
              padding: "10px 0px",
              width: "250px",
              marginRight: "17px",
            }}
            label={"Source ID"}
            InputLabelProps={{ style: { fontSize: "14px" } }}
            variant="standard"
            required
            error={error && !violation.sourceId}
            value={violation.sourceId || ""}
            name="sourceId"
            disabled={isSourceIdDisabled()}
            onChange={handleChange}
          />
          <Button
            style={{ width: "130px", height: "40px" }}
            disabled={isVerifyDisabled()}
            onClick={() => getFilesBySourceId()}
            variant="outlined"
          >
            Verify
          </Button>
          <div style={{ padding: "5px" }}>
            {loading && (
              <CircularProgress
                style={{ width: "30px", height: "30px", marginLeft: "10px" }}
              />
            )}
          </div>
        </div>
        {sourceIdStatus === "verified" && violation.sourceIdType ? (
          <span style={{ color: "green" }} className="text-5B5B5B-14px normal">
            Verified
          </span>
        ) : sourceIdStatus === "error" && violation.sourceIdType ? (
          <span style={{ color: "red" }} className="text-5B5B5B-14px normal">
            {violation.sourceIdType === "mail"
              ? "Mail"
              : violation.sourceIdType === "email"
              ? "Email"
              : ""}{" "}
            Source ID not found
          </span>
        ) : (
          <></>
        )}
      </Stack>
      <Stack maxWidth={"380px"}>
        <div
          className="sub-title-text-2"
          style={{ margin: "12px 0px 0px 0px" }}
        >
          Notice
        </div>
        <>
          {files?.length > 0 ? (
            <>
              {Array.from(files).map((file: any, index: number) => (
                <div style={{ cursor: "pointer" }} className="ov-pdf-container">
                  <Stack direction={"row"} alignItems={"center"}>
                    <PictureAsPdf style={{ width: "20px", height: "20px" }} />
                    <span
                      style={{ marginLeft: "14px" }}
                      className="text-3E3E3E-14px normal"
                    >
                      {file.fileName
                        ? file.fileName
                        : file.name
                        ? file.name
                        : file}
                    </span>
                  </Stack>
                  <DeleteOutline
                    onClick={() => deleteModalOpen(index)}
                    style={{ width: "20px", height: "20px", color: "#3576E5" }}
                  />
                </div>
              ))}
            </>
          ) : violation.sourceIdType === "mail" ? (
            <>
              {selectedFileFromMail ? (
                <>
                  {
                    <div
                      style={{ cursor: "pointer" }}
                      className="ov-pdf-container"
                    >
                      <Stack direction={"row"} alignItems={"center"}>
                        <PictureAsPdf
                          style={{ width: "20px", height: "20px" }}
                        />
                        <span
                          style={{ marginLeft: "14px" }}
                          className="text-3E3E3E-14px normal"
                        >
                          {selectedFileFromMail}
                        </span>
                      </Stack>
                      <DeleteOutline
                        onClick={deleteSelectedFile}
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "#3576E5",
                        }}
                      />
                    </div>
                  }
                </>
              ) : (
                <div style={{ marginTop: "16px" }}>
                  No documents to show yet. Please enter the Source ID above.
                </div>
              )}
            </>
          ) : violation.sourceIdType === "email" ? (
            <>
              {emailFilesOptions?.length > 0 ? (
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel id="demo-simple-select-standard-label">
                    Select Document
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={selectedFileFromEmail}
                    onChange={handleSelectFileFromEmail}
                    label="selectedEmailFile"
                    multiple
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value: string) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                  >
                    {emailFilesOptions.map((file: any) => {
                      return (
                        <MenuItem value={file}>
                          <Checkbox
                            checked={selectedFileFromEmail.includes(file)}
                          />
                          <ListItemText primary={file} />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              ) : (
                <div style={{ marginTop: "16px" }}>
                  No documents to show yet. Please enter the Source ID above.
                </div>
              )}
            </>
          ) : (
            <div style={{ marginTop: "16px" }}>
              No documents to show yet. Please enter the Source ID above.
            </div>
          )}
        </>
      </Stack>
    </div>
  );
};

export default SourceIdVerificationComp;
